import { Lock } from 'lucide-react'

import { quotesSectionHref, type SummarySectionKey } from '@/components/quotes/ApplicationSummarySection'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'

/**
 * Why a roster is read-only once carriers hold it: the change has to reach the broker,
 * so it goes through the quotes page rather than landing on the row the quotes priced.
 */
export function QuotesLockNotice({ section }: { section: SummarySectionKey }) {
  return (
    <Card className="items-center gap-4 px-6 py-8 text-center">
      <div className="bg-ink-50 flex size-10 items-center justify-center rounded-full">
        <Lock className="text-ink-500 size-5" />
      </div>
      <p className="text-md text-ink-600 max-w-xl">
        Need to update your application info? Make adjustments at the top of your Quotes Page, and your broker
        will review the request, and be in touch about getting updated pricing.
      </p>
      <Button href={quotesSectionHref(section)}>View your Quotes</Button>
    </Card>
  )
}
